export const SCENE_HDRI_BACKGROUND_VISIBILITY_EVENT = "scene-hdri-background-visibility-changed";
export const SCENE_PLAIN_BACKGROUND_COLOR = "#111827";

let sceneHdriBackgroundVisible = true;
const listeners = new Set();

export function getSceneHdriBackgroundVisible() {
  return sceneHdriBackgroundVisible;
}

export function setSceneHdriBackgroundVisible(visible) {
  const next = Boolean(visible);
  if (sceneHdriBackgroundVisible === next) return sceneHdriBackgroundVisible;
  sceneHdriBackgroundVisible = next;
  listeners.forEach((listener) => listener(sceneHdriBackgroundVisible));
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(SCENE_HDRI_BACKGROUND_VISIBILITY_EVENT, {
        detail: { visible: sceneHdriBackgroundVisible },
      })
    );
  }
  return sceneHdriBackgroundVisible;
}

export function subscribeSceneHdriBackgroundVisibility(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
